module.exports = __webpack_public_path__ + "img/20230515162516_78460.cc19180a.jpg";